// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__nr+E3","nav1":"Navbar_nav1__4FB+s","logo":"Navbar_logo__-mhgL","nav1H":"Navbar_nav1H__WFCDp","anchor":"Navbar_anchor__jTu85","nav2":"Navbar_nav2__TT3Mz"};